const $collapseContainers = $('.js-answer-collapse');

const answerCollapse = {
  initialize() {
    if (!$collapseContainers.length) {
      return;
    }

    $('body').on('click', '.js-answer-collapse-toggle', (event) => {
      const $parent = $(event.currentTarget).parents('.js-answer-collapse');

      if (!$parent.length) {
        return false;
      }

      const $preview = $parent.find('.js-answer-collapse-preview');
      $preview.hide();

      const $complete = $parent.find('.js-answer-collapse-complete');
      $complete.show();

      return true;
    });
  },
};

export default answerCollapse;
